import React, { useEffect, useState, useContext } from 'react'
import { Tooltip } from '@mui/material'
import { Search } from '@mui/icons-material'
import { MInputTextField, MElementDrawer, MTable, BufferService, FiltersSortService, LoadingContext } from '../../M_Components'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

export function MDrawerTableTextField({
    label, value, entity, filterField, fieldType, tableLabel, color,
    secondColor, FILTER, required, tooltipAdd, disabled, labelFields,
    onSubmitValue, size, icon, valueIdField, multiple, tableMaxRows,
    filtersOnTable, removeHeaders, inputFilter, disabledBorderColor }) {

    const { t } = useTranslation()
    const [valueInput, setValueInput] = useState(value)
    const [onOpen, setOnOpen] = useState(false)
    const [options, setOptions] = useState([])
    const [selectedRows, setSelectedRows] = useState([])
    const headerSize = document.body.getElementsByClassName('p-datatable-header')[0]?.offsetHeight || 60
    const paginatorSize = document.body.getElementsByClassName('paginator')[0]?.offsetHeight || 60
    const tabSize = 64
    const tempSize = (document.body.offsetHeight - (headerSize + paginatorSize + tabSize + 5))
    const entityService = new BufferService(entity)
    const filterService = new FiltersSortService()
    const ctx = useContext(LoadingContext)

    color = color || ctx.primaryColor || 'var(--color-black)'

    useEffect(() => {
        setSelectedRows([])
        setOptions([])
    }, [value])

    useEffect(() => {
        if (value !== valueInput) {
            setValueInput(value)
        }
    }, [value, valueInput])

    const openDrawer = () => {
        setOnOpen(true)
    }

    const closeDrawer = () => {
        setOnOpen(false)
    }

    const keyDown = (e) => {
        if (e.key === 'F4') {
            openDrawer()
        }
    }

    const getLine = (e) => {
        if (multiple) {
            setSelectedRows(e)
        } else {
            closeDrawer()
            onChangeValue(null, e[0], 'changevalue')
        }
    }
    const onSave = () => {
        onSubmitValue(selectedRows)
        closeDrawer()
    }

    const returnTable = () => {
        if (onOpen) return (
            <>
                <h2 style={{ marginLeft: '10px', marginTop: '0px', marginBottom: '10px' }}>{tableLabel}</h2>
                <MTable
                    inputFilter={inputFilter}
                    removeHeaders={removeHeaders}
                    filtersOnTable={!filtersOnTable}
                    maxRows={tableMaxRows}
                    tableHeight={tempSize}
                    entityName={entity}
                    useSessionStorage={false}
                    crud={false}
                    onPassLine={getLine}
                    selectSingle={!multiple}
                    FILTER={FILTER}
                    value={value}
                    valueIdField={valueIdField}
                    multiple={multiple}
                    extraButtons={multiple && [{ label: t("Save"), element: 'default', icon: <img src="./icons/svgsDaNet/save.svg" style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }} alt="save" />, command: () => onSave() }]}
                />
            </>
        )
        return null
    }

    const getValues = (input) => {
        if (filterField && fieldType) {
            const tempArg = [{ name: filterField, type: fieldType, operation: 'Contains', value: input }]
            const tempFilter = filterService.queryBuilder(1, 5, null, tempArg, FILTER)
            entityService.filter(tempFilter).then(res => {
                if (res.name === 'AxiosError') {
                    return
                }
                setOptions(res.Items)
            })
        }
    }

    const onChangeValue = (event, value, reason) => {
        setValueInput(value)
        onSubmitValue(value)
    }

    const clickOption = (option) => {
        getLine([option])
    }

    return (
        <>
            {multiple ?
                ''
                :
                <MInputTextField
                    data-testid="input-field"
                    disabledBorderColor={disabledBorderColor}
                    autocomplete
                    options={options}
                    disabled={disabled}
                    label={label}
                    value={valueInput}
                    onClickOption={clickOption}
                    labelFields={labelFields}
                    onChangeValue={onChangeValue}
                    onChange={(e) => getValues(e.target.value)}
                    onKeyDown={(e) => keyDown(e)}
                    color={color}
                    secondColor={secondColor}
                    required={required}
                    size={size}
                    InputProps={{
                        startAdornment: (
                            disabled ? <></> :
                                <Tooltip
                                    data-testid="tooltip"
                                    style={{ color: color, cursor: 'pointer' }}
                                    title={tooltipAdd || ""}
                                    onClick={() => openDrawer()}
                                >
                                    {icon || <Search />}
                                </Tooltip>
                        ),
                    }}
                />}
            <MElementDrawer
                data-testid="drawer"
                open={onOpen}
                setOpen={setOnOpen}
                onClose={closeDrawer}
                element={returnTable()}
            />
        </>
    )
}

MDrawerTableTextField.propTypes = {
    label: PropTypes.string,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    entity: PropTypes.string,
    filterField: PropTypes.string,
    fieldType: PropTypes.string,
    tableLabel: PropTypes.string,
    color: PropTypes.string,
    secondColor: PropTypes.string,
    FILTER: PropTypes.string,
    required: PropTypes.bool,
    tooltipAdd: PropTypes.string,
    disabled: PropTypes.bool,
    labelFields: PropTypes.array,
    onSubmitValue: PropTypes.func,
    size: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
    icon: PropTypes.element,
    valueIdField: PropTypes.string,
    multiple: PropTypes.bool,
    tableMaxRows: PropTypes.number,
    filtersOnTable: PropTypes.bool,
    removeHeaders: PropTypes.array,
    inputFilter: PropTypes.bool,
    disabledBorderColor: PropTypes.string
}